import React, { useState, useEffect } from 'react'
import { Panel, Grid, Row, Placeholder, Col, Icon } from 'rsuite'
import { DEFAULT_ICON_COLOR } from '../../../../constants/color'
import Form9AttachFilesWidget from './Form9AttachFilesWidget'

export default function BackgroundForm9View({ schema }) {
  const { Graph } = Placeholder

  const HtmlDisplay = ({ data }) => {
    return (
      <div style={{ marginTop: 10 }}>
        <p>{data.label}</p>

        {data.value ? (
          <div style={{ marginLeft: 20 }} dangerouslySetInnerHTML={{ __html: data.value }} />
        ) : (
          <div>
            <Graph height={9} width={'95%'} style={{ marginLeft: '5%' }} />
            <Graph height={9} />
            <Graph height={9} />
          </div>
        )}
      </div>
    )
  }

  const RadioDisplay = ({ data, otherKey }) => {
    return (
      <div style={{ marginTop: 10 }}>
        <p>{data.label}</p>

        {data.options?.map((item, index) => {
          return (
            <div key={data.name + '_' + index} style={{ marginLeft: 20 }}>
              <Icon
                icon={data.value == item.value ? 'check-circle' : 'circle'}
                style={
                  data?.value?.includes(item.value)
                    ? { color: '#14997A' }
                    : { color: DEFAULT_ICON_COLOR }
                }
              />
              <label style={{ marginLeft: 10 }}>{`${item.label} ${
                data?.value?.includes(item.value) && item.value == '99' && schema[otherKey]
                  ? schema[otherKey]
                  : ''
              }`}</label>
            </div>
          )
        })}
      </div>
    )
  }

  return (
    <>
      {schema && (
        <Panel header="">
          <Grid fluid>
            <Row>
              {schema.backgroundDescription && (
                <Col>
                  <HtmlDisplay data={schema.backgroundDescription} />
                </Col>
              )}

              {schema.generalAreaInformation && (
                <Col>
                  <HtmlDisplay data={schema.generalAreaInformation} />
                </Col>
              )}

              {schema.rootCauseAnalys && (
                <Col>
                  <HtmlDisplay data={schema.rootCauseAnalys} />
                </Col>
              )}

              {schema.problemLevel && (
                <Col>
                  <RadioDisplay data={schema.problemLevel} otherKey="problemLevelOther" />
                </Col>
              )}

              {schema.problemSolve && (
                <Col>
                  <HtmlDisplay data={schema.problemSolve} />
                </Col>
              )}

              {schema.problemSolution && (
                <Col>
                  <RadioDisplay data={schema.problemSolution} otherKey="problemSolutionOther" />
                </Col>
              )}
            </Row>
            <Row>
              {schema.attachment && (
                <Col>
                  <div style={{ paddingTop: 10 }}>
                    <Form9AttachFilesWidget schema={schema.attachment} isEdit={false} />
                  </div>
                </Col>
              )}
            </Row>
          </Grid>
        </Panel>
      )}
    </>
  )
}
